import { apiSlice } from "./apiSlice";

const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (user) => ({
        url: "/user/login",
        method: "POST",
        body: user,
      }),
    }),
    signup: builder.mutation({
      query: (user) => ({
        url: "/user/signup",
        method: "POST",
        body: user,
      }),
    }),
    verifyUser: builder.mutation({
      query: (user) => ({
        url: "/user/verifyUser",
        method: "POST",
        body: user,
      }),
    }),
    checkValidOtp: builder.mutation({
      query: ({ encryptedOTP, optEnteredByUser, token }) => ({
        url: "/user/checkValidOTP",
        method: "POST",
        body: { encryptedOTP, optEnteredByUser },
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    checkValidOtpForForgetPassword: builder.mutation({
      query: ({ encryptedOTP, optEnteredByUser, email }) => ({
        url: "/user/checkValidOTPForForgetPassword",
        method: "POST",
        body: { encryptedOTP, optEnteredByUser, email },
      }),
    }),
    forgotPassword: builder.mutation({
      query: (user) => ({
        url: "/user/forgotPassword",
        method: "POST",
        body: user,
      }),
    }),

    resetPassword: builder.mutation({
      query: (user) => ({
        url: "/user/changePassword",
        method: "PATCH",
        body: user,
      }),
    }),
    resetForgetPassword: builder.mutation({
      query: ({ newPassword, token }) => ({
        url: "/user/resetForgetPassword",
        method: "PATCH",
        body: { newPassword },
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useSignupMutation,
  useVerifyUserMutation,
  useCheckValidOtpMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useCheckValidOtpForForgetPasswordMutation,
  useResetForgetPasswordMutation,
} = authApi;
